import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router, Route } from "@angular/router";
import { AlertService, GrowlType } from "app/infrastructure/services/alert.service";
import { Translator } from "angular-translator";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmacionModalComponent } from "app/helpers/components/confirmationModal/confirmationModal.component";
import { BusinessLogicService } from "app/infrastructure/services/businessLogic.service";
import { BusinessLogic } from "app/infrastructure/model/interfaces/businessLogic.interface";

@Component({
  selector: "sx-business-logic-list",
  templateUrl: "./business-logic-list.component.html",
})
export class BusinessLogicListComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  documentKind: string;
  preguntarSiDeseaBorrar = [];
  businessLogic: BusinessLogic[] = new Array<BusinessLogic>();

  constructor(
    private businessLogicSrv: BusinessLogicService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private alertService: AlertService,
    private translate: Translator,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params["codorganizacion"];
      this.subscriptionCode = params["codsistema"];
      this.channelCode = params["codnegocio"];
      this.productCode = params["codproducto"];
      this.documentKind = params["documentKind"];

      if (this.productCode === undefined) {
        this.businessLogicSrv
          .getAll()
          .subscribe((res) => (this.businessLogic = res));
      } 
      else {
        this.businessLogicSrv
          .getAllSubscribed(
            this.organizationCode,
            this.subscriptionCode,
            this.channelCode,
            this.productCode
          )
          .subscribe((res) => this.businessLogic = res);
      }
    });
  }

  // --------------------------------------------------------------------
  // flows
  clickEdit(idBusinessLogic: string) {
    this.router.navigate([".", idBusinessLogic], { relativeTo: this.aRoute });
  }

  clickDelete(idBusinessLogic: string, name: string) {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);
    const modalInstance = <ConfirmacionModalComponent>(
      modalRef.componentInstance
    );
    const text = <string>this.translate.instant("DISABLE_TEXT");
    //const businessLogicReferences = <string>this.translate.instant('DISABLE_BUSINESS_LOGIC_REFERENCES');

    modalInstance.titulo = `${text} ${name}?`;
    modalRef.result.then((confirmacion) => {
      if (this.productCode === undefined) {
        // IN THIS CASE, DELETE THE BUSINESS LOGIC
        this.businessLogicSrv.delete(idBusinessLogic).then((success) => {
          if (success) {
            this.alertService.showGrowl(
              {
                type: GrowlType.SUCCESS,
                body: "SUCCESSFUL_DELETE_BUSINESS_LOGIC",
              },
              { name: name }
            );
          } else {
            this.alertService.showGrowl(
              {
                type: GrowlType.DANGER,
                body: "COULD_NOT_DELETE_BUSINESS_LOGIC",
              },
              { name: name }
            );
          }
          this.businessLogic = this.businessLogic.filter(
            (f) => f.idBusinessLogic !== idBusinessLogic
          );
        });
      } // IN THIS CASE, UNSUBSCRIBE THE BUSINESS LOGIC FROM CONTEXT
      else {
        this.businessLogicSrv.unsubscribe(idBusinessLogic).then((success) => {
          if (success) {
            this.alertService.showGrowl(
              {
                type: GrowlType.SUCCESS,
                body: "SUCCESSFUL_DELETE_BUSINESS_LOGIC",
              },
              { idBusinessLogic: idBusinessLogic }
            );
          } else {
            this.alertService.showGrowl(
              {
                type: GrowlType.DANGER,
                body: "COULD_NOT_DELETE_BUSINESS_LOGIC",
              },
              { idBusinessLogic: idBusinessLogic }
            );
          }
          this.businessLogic = this.businessLogic.filter(
            (f) => f.idBusinessLogic !== idBusinessLogic
          );
        });
      }
    });
  }

  isPolicy() {
    return this.documentKind === "Policy";
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/businesslogic/business-logic-list.component.ts